import React from 'react';
import ReactDOM from 'react-dom';
import styles from './index.css';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { Player } from 'ThreeTerminal_pc_dynamic';

class PicSlide extends React.PureComponent {
    static propTypes = {
        picSlideData: PropTypes.object,
        handlePicPrev: PropTypes.func,
        handlePicNext: PropTypes.func,
        handleBigOpen: PropTypes.func,
        handleVideoPlay: PropTypes.func,
    };

    /**
     * 渲染组件
     */
    render() {
        const { handlePicPrev, handlePicNext, handleBigOpen, handleVideoPlay, picSlideData } = this.props;
        const { current, slideData, total, videoPlay, picCurrentH, picContainerH } = picSlideData;

        // 当前展示对象
        const item = slideData && slideData[current] ? slideData[current] : {};

        const playermsg = {
            width: (picContainerH * 16) / 11,
            height: picContainerH,
            isAuth: 'auth',
            autoPlay: true,
            poster: item ? item.posterUrl : '',
        };

        const type = item.type;
        // pic
        const picItem = <img style={{ height: picCurrentH }} src={item.url} />;
        // video
        const videoItem = videoPlay ? (
            <Player videoConfig={item} playermsg={playermsg} />
        ) : (
            <div>
                <img style={{ height: 'auto' }} src={item.posterUrl} />
                <div className={styles.video_btn} onClick={handleVideoPlay} />
            </div>
        );

        // 视频

        return (
            <div className={styles.container} id="forAd">
                <div className={styles.picSet}>
                    <div className={styles.swiper_container}>
                        <table className={styles.swiper_wrapper}>
                            <tbody>
                                <tr>
                                    <td style={{ height: picContainerH }}>
                                        <div className={styles.photoOperate}>
                                            {type === 'video' ? videoItem : picItem}
                                            <div className={styles.bigOpen} onClick={handleBigOpen} />
                                            <a className={styles.download} href={item.url} target="_blank" />
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <a className={current === 0 ? styles.picPrev : styles.picPrev_hover} onClick={handlePicPrev} />
                    <a className={styles.picNext} onClick={handlePicNext} />
                </div>

                <div className={styles.picTxt}>
                    <div className={styles.picPage}>
                        <span className={styles.pageCurrent}>{current + 1}</span>{' '}
                        <span className={styles.line02}>/</span> <span className={styles.pageTotal}>{total}</span>{' '}
                    </div>
                    <ul>
                        <li>
                            <h2>{item.title}</h2>
                            <p className={styles.photoDesc}>{item.description || item.title}</p>
                        </li>
                    </ul>
                </div>
            </div>
        );
    }
}

export default errorBoundary(PicSlide);
